import { 
  Project, 
} from '../types/projects';
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const projectsApi = appApi.injectEndpoints({
  endpoints: (build) => ({

    getProjects: build.query<any, void>({
      query: () => ({
        url: appEndpoint.getProjects,
        method: 'get',
      }),
      providesTags: ['Project'],
    }),
    addProject: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.createProject,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Project"] : []),
    }),

    updateProject: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.updateProject}/${data.id}?_method=put`,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Project"] : []),
    }),
    
    // getUnitTypes: build.query<any, void>({
    //   query: () => ({
    //     url: appEndpoint.getUnitTypes,
    //     method: 'get',
    //   }),
    //   providesTags: ['UnitTypes'],
    // }),

    getProjectById: build.query<any, string>({
      query: (id) => ({
        url: `${appEndpoint.getProjects}/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [{ type: 'ProjectDetail', id }],
    }),
    
    deleteLegalDocument: build.mutation<any, String>({
      query: (id) => ({
        url: `${appEndpoint.legalDocuments}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: (result) => (result ? ["ProjectDetail"] : []),
    }),

      addLegalDocument: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.legalDocuments,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["ProjectDetail"] : []),
    }),

    deleteProject: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.deleteProject}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Project'],
    }),

  }),
  overrideExisting: false,
});

// Export hooks for usage in components
export const {
  useGetProjectsQuery,
  useGetProjectByIdQuery,
  useDeleteProjectMutation,
  // useGetUnitTypesQuery,
  useUpdateProjectMutation,
  useAddProjectMutation,
  useDeleteLegalDocumentMutation,
  useAddLegalDocumentMutation
} = projectsApi;